import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ItemCard from "@/components/ItemCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    api.get("/items", { params: { user_id: user.id } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [user]);

  const groups = {
    available: items.filter((i) => i.status === "available"),
    claimed:   items.filter((i) => i.status === "claimed"),
    gone:      items.filter((i) => i.status === "gone"),
  };

  return (
    <div className="min-h-[calc(100vh-4rem)]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] text-[#7C3AED] font-medium">Your posts</span>
            <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium mt-2">
              Hi {user?.name?.split(" ")[0]}
            </h1>
            <p className="text-[#6B7280] mt-1">A look at the items you've shared with the neighbourhood.</p>
          </div>
          <Button asChild className="rounded-full bg-[#7C3AED] hover:bg-[#5B21B6] text-white" data-testid="profile-post-btn">
            <Link to="/post"><Plus className="h-4 w-4 mr-1" />New post</Link>
          </Button>
        </div>

        <Tabs defaultValue="available" className="mt-8">
          <TabsList className="bg-white border border-[#E8E5F0] rounded-full p-1">
            <TabsTrigger value="available" className="rounded-full" data-testid="tab-available">
              Available · {groups.available.length}
            </TabsTrigger>
            <TabsTrigger value="claimed" className="rounded-full" data-testid="tab-claimed">
              Claimed · {groups.claimed.length}
            </TabsTrigger>
            <TabsTrigger value="gone" className="rounded-full" data-testid="tab-gone">
              Gone · {groups.gone.length}
            </TabsTrigger>
          </TabsList>

          {Object.entries(groups).map(([k, list]) => (
            <TabsContent key={k} value={k} className="mt-6">
              {loading ? (
                <div className="text-[#6B7280]">Loading…</div>
              ) : list.length === 0 ? (
                <div className="bg-white border border-[#E8E5F0] rounded-2xl p-10 text-center text-[#6B7280]">
                  Nothing here yet.
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {list.map((it) => <ItemCard key={it.id} item={it} />)}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
